import axios from "axios";
const URL = process.env.REACT_APP_MASTER_URL;

export async function addDiscount(data) {
  let url = `${URL}/enquiry/sharepointlist/addDiscount`;
  let response = await axios.post(url, data);
  return response.data;
}

export async function getDiscount() {
  const url = `${URL}/enquiry/dynamicform/discountsanction`;
  let response = await axios.get(url);
  return response.data;
}

export async function getSalesUser() {
  const url = `${URL}/enquiry/sharepointlist/getSalesUser`;
  let response = await axios.get(url);
  return response.data;
}